import { Link } from "react-router-dom";
import {
  CalendarCheck,
  Mail,
  Search,
  BrainCircuit,
  Users,
  Share2,
  ArrowUpRight,
} from "lucide-react";
import { Container, Section, Eyebrow, Reveal } from "@/components/kit";
import { cn } from "@/lib/utils";

const services = [
  {
    icon: CalendarCheck,
    title: "Appointment Setting",
    desc: "Qualified, ICP-matched meetings booked straight to your calendar — the core of Appointment Lab.",
    span: "lg:col-span-2",
    feature: true,
  },
  {
    icon: Mail,
    title: "Email Campaigns",
    desc: "Deliverability-obsessed cold email at scale with warmed infrastructure.",
    span: "",
  },
  {
    icon: Search,
    title: "ICP Research",
    desc: "TAM mapping, account scoring and contact enrichment done deep.",
    span: "",
  },
  {
    icon: BrainCircuit,
    title: "AI Intent Signals",
    desc: "Detect in-market accounts from real-time buying and hiring signals.",
    span: "",
  },
  {
    icon: Users,
    title: "SDR as a Service",
    desc: "A trained outbound team plugged into your motion, minus the overhead.",
    span: "",
  },
  {
    icon: Share2,
    title: "Multi-Channel Outreach",
    desc: "Email, LinkedIn and phone orchestrated into one coherent, high-converting sequence across every touchpoint.",
    span: "lg:col-span-2",
    feature: true,
  },
];

export const ServicesBento = () => (
  <Section data-testid="services-bento" className="bg-navy-800/30 border-y border-white/10">
    <Container>
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div className="max-w-2xl">
          <Eyebrow>What We Run</Eyebrow>
          <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl font-medium tracking-tight text-white">
            One lab. Six systems.
          </h2>
        </div>
        <Link
          to="/services"
          data-testid="bento-all-services"
          className="group inline-flex items-center gap-2 font-mono-jb text-sm text-gold hover:text-white transition-colors"
        >
          Explore all services
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
        </Link>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {services.map((s, i) => (
          <Reveal key={s.title} delay={(i % 3) * 0.08} className={s.span}>
            <div
              className={cn(
                "group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-navy-900 p-8 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-2 hover:border-gold/50 hover:shadow-[0_0_40px_rgba(255,215,0,0.12)]",
                s.feature && "md:min-h-[220px]"
              )}
            >
              {s.feature && (
                <div className="pointer-events-none absolute -right-10 -top-10 h-40 w-40 gold-radial opacity-70" />
              )}
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gold/10 border border-gold/25 text-gold transition-colors duration-300 group-hover:bg-gold group-hover:text-navy-900">
                <s.icon className="h-6 w-6" />
              </div>
              <h3 className="mt-6 font-display text-xl font-semibold text-white">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-white/55 max-w-md">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </Container>
  </Section>
);
